import React from 'react';
import { Board } from '../../board';
import { Banner, SEO } from '../../common';
import { Layout } from '../../layout';

export default function BoardPage() {
  return (
    <Layout>
      <SEO title="Junta Directiva" />
      <Banner
        text={
          <>
            Junta
            <br />
            Directiva
          </>
        }
      />
      <Board />
    </Layout>
  );
}
